import { Drawer } from "@mui/material";
import React from "react";

import { SidebarDrawerContent } from "./SidebarDrawerContent";

interface AppSidebarProps {
  mobileOpen: boolean;
  onClose: () => void;
  defaultDrawerWidth: number;
  onMenuItemClick?: () => void;
}
export const AppSidebar: React.FC<AppSidebarProps> = (props) => {
  const { mobileOpen, onClose, defaultDrawerWidth, onMenuItemClick } = props;

  return (
    <>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            width: defaultDrawerWidth,
            boxSizing: "border-box",
            borderRight: "none",
          },
        }}
      >
        <SidebarDrawerContent
          actualDrawerWidth={defaultDrawerWidth}
          onMenuItemClick={onMenuItemClick}
        />
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          width: defaultDrawerWidth,
          overflowX: "hidden",
          "& .MuiDrawer-paper": {
            width: defaultDrawerWidth,
            boxSizing: "border-box",
            overflowX: "hidden",
          },
        }}
        open
      >
        <SidebarDrawerContent
          actualDrawerWidth={defaultDrawerWidth}
          onMenuItemClick={onMenuItemClick}
        />
      </Drawer>
    </>
  );
};
